import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import styles from './ColorSwatch.scss';
export var ColorSwatch = function ColorSwatch(_ref) {
  var active = _ref.active,
      color = _ref.color,
      dataTest = _ref.dataTest,
      onClick = _ref.onClick;
  var styleObj;

  if (color) {
    styleObj = {
      backgroundColor: color
    };
  }

  return React.createElement("div", {
    role: "button",
    className: styles.root,
    "data-test": dataTest,
    onClick: onClick,
    tabIndex: 0
  }, React.createElement("div", {
    className: classnames(styles.swatch, _defineProperty({}, styles.active, active)),
    style: styleObj
  }), React.createElement("div", {
    style: styleObj,
    className: styles.bg
  }));
};
ColorSwatch.defaultProps = {
  active: false
};